export const light = {
  primary: '#3200e6',
  /* Custom colors to use. */
  geoGreen: '#23af82',
  geoViolet: '#cc69a5',
  geoGray: '#575757',
  geoLightGray: '#999daf',
  geoYellow: '#ffd719',
  geoOrange: '#f59114',
  geoMagenta: '#e60050',
  geoCyan: '#03c2e9',
  geoPurple: '#8331f1',
  geoBlue: '#3200e6',
  geoDarkBlue: '#020b39'
}

export const red = {
  primary: '#da1818'
}

export const green = {
  primary: '#39bd72'
}

export const black = {
  primary: '#000000'
}
